import type { FaireProductEntity } from "../../entity_types/product";

export const p_tt2ey5tumn: FaireProductEntity = {
  token: "p_tt2ey5tumn",
  type: "product",
  name: 'Sand Dollar Key Chain 2 1/2"',
  brandName: "Sea Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/de02afef502307ffe350d5878590464318c3c7c6fe1ecc76c842402b6490a7f5.jpeg",
  priceDollars: 2.3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/061a1f0ec1da27d2d93d737800d735162a7bdb1682d0cc67c6aa9be4a46d411d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
